export const ZeroBeta = () => (
  <svg
    width={101}
    height={24}
    viewBox="0 0 101 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M94.408 12.044c.144-1.416 1.32-2.28 3.096-2.28 1.956 0 3.18 1.056 3.18 2.76V17h-1.548v-1.284c-.348.864-1.272 1.38-2.484 1.38-1.512 0-2.472-.804-2.472-2.064 0-1.32 1.044-2.16 2.868-2.316l2.052-.18v-.096c-.072-.876-.648-1.392-1.596-1.392-.804 0-1.368.372-1.488.996h-1.608zm2.604 3.792c1.212 0 2.052-.732 2.1-1.86v-.216l-1.992.18c-.828.072-1.332.456-1.332 1.044 0 .54.444.852 1.224.852z"
      fill="url(#paint0_linear_163_552)"
    />
    <path
      d="M92.216 17.096c-1.308 0-1.968-.732-1.968-2.196v-3.672h-1.08V9.86h1.08V8.18h1.572v1.68h1.74v1.368h-1.74v3.492c0 .696.24.984.84.984.264 0 .612-.06.767-.132v1.332c-.204.108-.756.192-1.212.192z"
      fill="url(#paint1_linear_163_552)"
    />
    <path
      d="M85.196 9.764c2.028 0 3.492 1.392 3.492 3.336 0 .228-.024.444-.048.588h-5.4c.036 1.176.816 2.1 2.04 2.1.852 0 1.536-.48 1.704-1.188h1.62c-.216 1.5-1.56 2.496-3.372 2.496-2.184 0-3.636-1.452-3.636-3.636s1.476-3.696 3.6-3.696zm.048 1.308c-.972 0-1.716.624-1.896 1.56h3.684c-.156-.96-.84-1.56-1.788-1.56z"
      fill="url(#paint2_linear_163_552)"
    />
    <path
      d="M80.744 14.372c0 1.62-1.284 2.628-3.348 2.628h-3.804V7.4h3.54c2.016 0 3.3 1.02 3.3 2.616 0 .972-.48 1.716-1.272 2.004.96.3 1.584 1.224 1.584 2.352zm-2.016-4.224c0-.864-.648-1.332-1.848-1.332h-1.644v2.604h1.632c1.248 0 1.86-.42 1.86-1.272zm.312 4.08c0-.948-.624-1.416-1.92-1.416h-1.884v2.772h1.944c1.26 0 1.86-.444 1.86-1.356z"
      fill="url(#paint3_linear_163_552)"
    />
    <path
      d="M63.22 17.096c-2.723 0-4.56-1.98-4.56-4.896s1.837-4.896 4.56-4.896c2.725 0 4.56 1.98 4.56 4.896s-1.835 4.896-4.56 4.896zm0-1.428c1.657 0 2.845-1.452 2.845-3.456 0-2.016-1.2-3.48-2.844-3.48s-2.844 1.464-2.844 3.48c0 2.004 1.188 3.456 2.844 3.456z"
      fill="url(#paint4_linear_163_552)"
    />
    <path
      d="M57.59 10.508c0 1.284-.697 2.232-1.92 2.676L57.804 17h-1.8l-1.896-3.42h-1.836V17H50.63V7.4h3.324c2.196 0 3.636 1.224 3.636 3.108zm-1.705 0c0-1.056-.732-1.68-2.016-1.68h-1.596v3.36h1.596c1.284 0 2.016-.624 2.016-1.68z"
      fill="url(#paint5_linear_163_552)"
    />
    <path
      d="M44.334 12.8v2.772h4.656V17h-6.3V7.4h6.168v1.428h-4.524v2.568h4.092V12.8h-4.092z"
      fill="url(#paint6_linear_163_552)"
    />
    <path
      d="M40.914 8.6l-4.884 6.972h5.196V17H33.87v-1.2l4.896-6.972h-4.704V7.4h6.852v1.2z"
      fill="url(#paint7_linear_163_552)"
    />
    <path
      d="M19.498 22a1 1 0 11-2 0 1 1 0 012 0z"
      fill="url(#paint8_linear_163_552)"
    />
    <path
      d="M23.498 18a1 1 0 11-2 0 1 1 0 012 0z"
      fill="url(#paint9_linear_163_552)"
    />
    <path
      d="M3.498 6a1 1 0 11-2 0 1 1 0 012 0z"
      fill="url(#paint10_linear_163_552)"
    />
    <path
      d="M7.498 2a1 1 0 11-2 0 1 1 0 012 0z"
      fill="url(#paint11_linear_163_552)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.498 6.483l-.652 2.69a2.955 2.955 0 01-2.175 2.175L6.98 12l2.69.652a2.955 2.955 0 012.175 2.175l.652 2.69.652-2.69a2.955 2.955 0 012.175-2.175l2.69-.652-2.69-.652a2.955 2.955 0 01-2.175-2.175l-.652-2.69zm1.305-1.456c-.332-1.37-2.278-1.37-2.61 0l-.913 3.766c-.119.488-.5.87-.99.989l-3.765.913c-1.37.332-1.37 2.278 0 2.61l3.766.914c.489.118.87.5.989.988l.913 3.766c.332 1.37 2.278 1.37 2.61 0l.913-3.766c.119-.489.5-.87.99-.989l3.765-.913c1.37-.332 1.37-2.278 0-2.61l-3.766-.913c-.488-.119-.87-.5-.989-.99l-.913-3.765z"
      fill="url(#paint12_linear_163_552)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.503 22.315a.9.9 0 01-1.158.528 11.681 11.681 0 01-6.677-6.42.9.9 0 111.66-.695 9.881 9.881 0 005.646 5.429.9.9 0 01.529 1.158z"
      fill="url(#paint13_linear_163_552)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.813 9.02a.9.9 0 01-1.158-.527 9.88 9.88 0 00-5.488-5.66.9.9 0 11.684-1.666 11.68 11.68 0 016.49 6.695.9.9 0 01-.528 1.159z"
      fill="url(#paint14_linear_163_552)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_163_552"
        x1={45.998}
        y1={17}
        x2={52.7362}
        y2={-22.2333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_163_552"
        x1={45.998}
        y1={17}
        x2={52.7362}
        y2={-22.2333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_163_552"
        x1={45.998}
        y1={17}
        x2={52.7362}
        y2={-22.2333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_163_552"
        x1={45.998}
        y1={17}
        x2={52.7362}
        y2={-22.2333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_163_552"
        x1={45.998}
        y1={17}
        x2={52.7362}
        y2={-22.2333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_163_552"
        x1={45.998}
        y1={17}
        x2={52.7362}
        y2={-22.2333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_163_552"
        x1={45.998}
        y1={17}
        x2={52.7362}
        y2={-22.2333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_163_552"
        x1={45.998}
        y1={17}
        x2={52.7362}
        y2={-22.2333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_163_552"
        x1={-1.35619}
        y1={20.4357}
        x2={16.8157}
        y2={-2.46626}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_163_552"
        x1={-1.35619}
        y1={20.4357}
        x2={16.8157}
        y2={-2.46626}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_163_552"
        x1={-1.35619}
        y1={20.4357}
        x2={16.8157}
        y2={-2.46626}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_163_552"
        x1={-1.35619}
        y1={20.4357}
        x2={16.8157}
        y2={-2.46626}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_163_552"
        x1={-1.35619}
        y1={20.4357}
        x2={16.8157}
        y2={-2.46626}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_163_552"
        x1={-1.35619}
        y1={20.4357}
        x2={16.8157}
        y2={-2.46626}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_163_552"
        x1={-1.35619}
        y1={20.4357}
        x2={16.8157}
        y2={-2.46626}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E694" />
        <stop offset={0.39} stopColor="#0DBBFF" />
        <stop offset={0.73} stopColor="#E02181" />
        <stop offset={1} stopColor="#FF955F" />
      </linearGradient>
    </defs>
  </svg>
);
